module.exports = __webpack_public_path__ + "static/media/setting.f2367a95.png";